// extracted by mini-css-extract-plugin
export default {"formSelect":"FormSelect-module__formSelect"};